import { all, fork } from "redux-saga/effects";


import authSaga from "./auth/sagas";
import tourSaga from "./tour/sagas"

export function* rootSaga() {
    yield all([fork(authSaga),fork(tourSaga)]);
}